<template>
  <div>
    <Grid
      :headers="headers"
      @api="getTablets()"
      :payload="{results, count, next, prev}"
      :isCached="true"
      class="w-full h-full"
      @filter="showFilterModal = true"
      @clearFilters="$refs.desktopFilters.reset()"
    >
      <template #filter>
        <TabletsFilter ref="desktopFilters" />
      </template>
      <template #buttons>
        <base-button size="sm" @click="showActivateModal = true"> Register Device </base-button>
      </template>
      <!-- <TabletsCardItem :an-index="index" @refresh="filteredData" :tablet-item="item" /> -->
      <BaseCardLoader v-if="loading" n="4" />
      <template v-else>
        <ul
          class="grid 2xl:grid-cols-4 xl:grid-cols-3 lg:grid-cols-1 gap-x-5 gap-y-10 content-start"
        >
          <li v-for="item in filteredData" :key="item.android_id" class="">
            <!--                  Bubbling up event 'refresh' from TabletsCardItemEditModal.vue-->
            <TabletsCardItem
              @refresh="filteredData"
              @delete="getTablets"
              :tablet-item="item"
              :actions="true"
              @openDrawer="openDrawer"
            />
          </li>
        </ul>
      </template>
    </Grid>
    <TourMix
      v-if="showMixTour"
      :visible="showMixTour"
      :tablet="tablet"
      @close=";(showMixTour = false), getTablets()"
    />
    <TabletsActivate
      v-if="showActivateModal"
      @close="showActivateModal = false"
      @activation="getTablets"
      class="w-full"
    />

    <!-- Mobile filters -->
    <transition v-if="showFilterModal" name="grow">
      <base-modal @close="showFilterModal = false" head="filters" bg="white" full-width>
        <TabletsFilter :mobile="true" ref="mobileFilter" />
        <!-- Action buttons -->
        <div class="pt-4 mt-6 border-t flex flex-col justify-end w-full">
          <div class="flex flex-col">
            <div class="flex space-x-4">
              <base-button
                class="w-1/2"
                @click="
                  $refs.mobileFilter.reset()
                  showFilterModal = false
                "
                action="clear"
                context="secondary"
              >
                <base-icon icon="close" />
              </base-button>
              <base-button
                class="w-1/2"
                @click="
                  $refs.mobileFilter.submit()
                  showFilterModal = false
                "
                action="submit"
              >
                <base-icon icon="filters" />
              </base-button>
            </div>
          </div>
        </div>
      </base-modal>
    </transition>
  </div>
</template>

<script>
import {mapGetters, mapActions} from 'vuex'

import {
  BaseButtonIcon,
  BaseCardLoader,
  BaseButton,
  BaseModal,
  BaseInput,
  BaseIcon,
} from '@/components/base'
import SingleSelect from '@/components/shared/SingleSelect.vue'
import Grid from '@/components/shared/Grid.vue'
import TourMix from '../tours/TourMix.vue'

import TabletsCardItem from '@/components/pages/tablets/TabletsCardItem'
import TabletsFilter from '@/components/pages/tablets/TabletsFilter'
import TabletsActivate from './TabletsActivate.vue'

export default {
  // beforeRouteUpdate(to,from, next){
  //   this.addSearchFilter(to.query)
  //   next()
  // },
  // beforeRouteEnter(to,from,next) {
  //    next(vm => vm.addSearchFilter(to.query))
  // },
  async mounted() {
    this.tablets = await this.getCachedTablets()
  },
  data() {
    return {
      showFilterModal: false,
      searchTablet: '',
      drawerIsVisible: false,
      selectedTablet: null,
      tablets: null,
      companiesList: [],
      filterLoading: 0,
      filterFields: ['name', 'model', 'company', 'android_id', 'android_version'],
      showActivateModal: false,
      loading: true,
      showMixTour: false,
      tablet: {},
      tours: [],
    }
  },
  components: {
    TourMix,
    TabletsFilter,
    TabletsCardItem,
    BaseButtonIcon,
    BaseCardLoader,
    BaseButton,
    Grid,
    BaseModal,
    BaseInput,
    BaseIcon,
    SingleSelect,
    TabletsActivate,
  },
  methods: {
    async createSubscriptions() {
      for (let i = 1; i <= 11; i++) {
        console.log(i)
        try {
          await this.$store.dispatch('companies/createSubscription', {id: `${i}`})
        } catch (e) {
          console.log(e)
        }
      }
    },
    ...mapActions({
      tablets_getInitialTablets: 'tablets/getInitialTablets',
      companies_getAll: 'companies/getAll',
    }),

    async getTablets() {
      this.loading = true
      this.$store.dispatch('app/startApiCall')
      try {
        this.tablets = await this.$store.dispatch('tablets/getTablets')
      } catch (error) {}
      this.$store.dispatch('app/finishApiCall')
      this.loading = false
    },
    async getCachedTablets() {
      try {
        let payload = await this.tablets_getInitialTablets()
        this.loading = false

        return payload
      } catch (error) {}
    },
    async openDrawer(item) {
      this.tablet = item
      this.showMixTour = true
    },
  },
  computed: {
    count() {
      return this.tablets?.count
    },
    next() {
      return this.tablets?.next
    },
    previous() {
      return this.tablets?.previous
    },
    results() {
      return this.tablets?.results
    },
    filteredData() {
      if (!this.results) {
        return []
      }
      let tabletsArray
      tabletsArray = this.results
      // const matcher = new RegExp(this.searchTablet, 'i')
      // return this.filterFields.some(k => matcher.test(item[k]))

      //escaping special characters with regular expression
      let nameFilter = this.$route.query.tabletName || ''
      const matcher = new RegExp(nameFilter.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'), 'i')

      let androidFilter = this.$route.query.android_id || ''
      const androidMatcher = new RegExp(androidFilter.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'), 'i')

      let companyFilter = Array.from(this.$route.query.company || []).map(v => parseInt(v, 10))

      let activeFilter = this.$route.query.is_active || ''

      return tabletsArray
        .filter(value => matcher.test(value.name))
        .filter(value => androidMatcher.test(value.android_id))
        .filter(value => (companyFilter.length > 0 ? companyFilter.includes(value.company) : true))
        .filter(value => (activeFilter.length > 0 ? activeFilter.includes(value.is_active) : true))
    },
  },
}
</script>

<style>
.ant-input {
  @apply rounded-none;
}
.ant-drawer-content-wrapper {
  @apply md:w-1/2 w-4/5;
}
.ant-list-empty-text {
  @apply mt-10 text-xl font-thin;
}
</style>
